import { BaseApiService } from '@services/baseApiService';
import { ScheduleOutputDTO, ScheduleFilterParams } from '@features/schedule/types';
import { ApiResponse, ApiError } from '@/types/api';
import { api } from '@services/api';

export class ScheduleService extends BaseApiService<ScheduleOutputDTO> {
  constructor() {
    super('schedules');
  }

  async fetchActivities(filters: ScheduleFilterParams = {}): Promise<ApiResponse<ScheduleOutputDTO[]> | ApiError> {
    // Convert potential Date objects to strings
    const formattedFilters: Record<string, string> = {};
    
    if (filters.search) formattedFilters.search = filters.search;
    if (filters.product) formattedFilters.product = filters.product;
    if (filters.status) formattedFilters.status = filters.status;
    if (filters.priority !== undefined) formattedFilters.priority = filters.priority.toString();
    if (filters.startDate) formattedFilters.startDate = filters.startDate;
    if (filters.endDate) formattedFilters.endDate = filters.endDate;
    if (filters.page !== undefined) formattedFilters.page = filters.page.toString();
    if (filters.limit !== undefined) formattedFilters.limit = filters.limit.toString();
    
    console.log('📡 Fetching schedules with filters:', formattedFilters);
    return await this.fetchSchedulesStats(formattedFilters);
  }

  // Specific endpoint for fetching schedule stats
  async fetchSchedulesStats(filters: Record<string, string> = {}): Promise<ApiResponse<ScheduleOutputDTO[]>| ApiError> {
    const queryString = new URLSearchParams(filters).toString();
    const url = `${this.baseUrl}/stats${queryString ? `?${queryString}` : ''}`;
    
    console.log('📡 Requesting schedules from:', url);
    return await api.request<ScheduleOutputDTO[]>(url);
  }
}

export const scheduleService = new ScheduleService(); 